var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarThing4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2517 14.7106L59.8109 40.2872L81.7561 21.8688L70.1061 47.3545L99.0548 48.8988L72.02 59.3644L91.0144 79.9667L64.4314 69.2817L62.3448 96.8734L51.7856 71.2968L29.8404 89.7152L41.4903 64.2295L12.5417 62.6852L39.5765 52.2196L20.5821 31.6173L47.1651 42.3023L49.2517 14.7106Z",
    fill: "#DBF429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5603 12.3207L59.1195 37.8973L81.0647 19.4789L69.4147 44.9646L98.3634 46.5089L71.3286 56.9745L90.323 77.5768L63.74 66.8918L61.6534 94.4835L51.0942 68.907L29.149 87.3253L40.7989 61.8396L11.8503 60.2953L38.8851 49.8297L19.8907 29.2274L46.4737 39.9125L48.5603 12.3207Z",
    fill: "#43DAF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarThing4);
export default __webpack_public_path__ + "static/media/star_thing_4.f5e46943.svg";
export { ForwardRef as ReactComponent };